import { useEffect, useState } from 'react';
import { SelectLogmar, RandomETest, AcuityResults } from '..';
import { useTestContext } from '../../../context/testContext';
import { usePostMessage } from '../../../context/messageContext';
import ExamEyeSetup from '../exams/ExamEyeSetup';
import { ExamBody, useExamStep } from '../exams/common';

const RandomE = ({ setTitle, setActiveTab }) => {
  const { testData, updateTestData } = useTestContext();
  const [step, setStep] = useState('eyeSetup');
  const postMessage = usePostMessage();
  useExamStep(testData.testKey, step);

  useEffect(() => {
    switch (step) {
      case 'eyeSetup':
        setTitle('Random E Test');
        break;
      case 'rightEyeSetup':
        setTitle('Random E Test - Right Eye');
        break;
      case 'leftEyeSetup':
        setTitle('Random E Test - Left Eye');
        if (testData.testRightEye) updateTestData({ testInProgress: true });
        break;
      case 'bothEyesSetup':
        setTitle('Random E Test - Binocular');
        break;
      case 'rightEyeTest':
        setTitle('Random E Test - Right Eye');
        break;
      case 'leftEyeTest':
        setTitle('Random E Test - Left Eye');
        break;
      case 'bothEyesTest':
        setTitle('Random E Test - Binocular');
        break;
      case 'results':
        setTitle('Random E Test Results');
        break;
      default:
        break;
    }
  }, [setTitle, step, updateTestData, testData.testRightEye]);

  const updateStep = (selectedStep) => {
    if (selectedStep === 'results') postMessage({ type: 'endOfTest' });
    if (selectedStep.endsWith('Setup')) postMessage({ type: 'holding' });
    return setStep(selectedStep);
  };

  const renderSwitch = () => {
    switch (step) {
      case 'eyeSetup':
        return <ExamEyeSetup updateStep={updateStep} />;
      case 'bothEyesSetup':
      case 'rightEyeSetup':
      case 'leftEyeSetup':
        return <SelectLogmar eyeTested={step.split('S')[0]} updateStep={updateStep} />;
      case 'rightEyeTest':
      case 'leftEyeTest':
      case 'bothEyesTest':
        return <RandomETest eyeTested={step.split('T')[0]} updateStep={updateStep} />;
      case 'results':
        return <AcuityResults localResults={testData} setActiveTab={setActiveTab} updateStep={updateStep} />;
      default:
        return;
    }
  };

  return <ExamBody>{renderSwitch()}</ExamBody>;
};

export default RandomE;
